import { Box, createStyles, makeStyles, withStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useCallback } from "react";
//import UtilService from "../../../../../../helper/service";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";

const CustomSegmentBar = withStyles(() =>
  createStyles({
    root: {
      height: '50px',
      width: '100%',
      '@media screen and (max-width: 700px)': {
        height: '40px'
      },
    },
    colorPrimary: {
      backgroundColor: "#FFFFFF",
    },
    bar: (props: any) => ({
      borderRadius: '0px 10px 10px 0px',
      backgroundColor: props.barcolor
    })
  })
)(LinearProgress);

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 5,
    '@media screen and (max-width: 600px)': {
      paddingTop: 5
    }
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  parentCardSection: {
    marginTop: 40,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff',
    padding: '20px 40px 40px 40px',
    '@media screen and (max-width: 600px)': {
      padding: '10px'
    }
  },
  pdfParentCardSection: {
    marginTop: 40,
    borderRadius: 20,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    background: '#fff',
    padding: '20px 40px 40px 40px'
  },
  cardSection: {
    marginTop: 20,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff'
  },
  pdfCardSection: {
    marginTop: 20,
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  foo: {},
  segmentCardSection: {
    marginTop: 20,
    marginBottom: 30,
    borderRadius: 20,
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
    background: '#fff',
    padding: '20px 30px'
  },
  pdfSegmentCardSection: {
    marginTop: 20,
    marginBottom: 30,
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '20px 30px'
  },
  content: {
    padding: '0px 50px!important',
    '@media screen and (max-width: 600px)': {
      padding: '0px 10px!important'
    },
  },
  segmentContent: {
    padding: '0px 10px!important',
    '@media screen and (max-width: 600px)': {
      padding: '0px 10px!important'
    },
  },
  description: {
    fontSize: 16,
    fontFamily: 'roboto-medium',
    color: '#697683',
    marginTop: 40
  },
  bold: {
    fontFamily: 'roboto-black'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 70
  },
  segmentRow: {
    minHeight: '100px',
    '@media screen and (max-width: 700px)': {
      minHeight: '80px'
    },
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-bold',
    color: '#697683',
    display: 'flex',
    alignItems: 'center',
    flex: 3,
    '@media (max-width: 768px)': {
      flex: 5,
    },
    '@media screen and (max-width: 600px)': {
      fontSize: 14
    }
  },
  segmentTagName: {
    fontFamily: 'roboto-bold',
    fontSize: 16,
    color: '#697683',
    flex: 1,
    paddingRight: 10,
    wordBreak: 'break-all',
    '@media screen and (max-width: 750px)': {
      fontSize: 12
    }
  },
  segmentBarDiv: {
    flex: 4
  },
  percentage: {
    fontSize: 32,
    fontFamily: 'Spartan-bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
    '@media (max-width: 768px)': {
      flex: 5
    },
    '@media screen and (max-width: 600px)': {
      fontSize: 26
    }
  },
  participantCount: {
    fontSize: 32,
    fontFamily: 'Spartan-medium',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 2,
    '@media screen and (max-width: 600px)': {
      fontSize: 26
    }
  },
  participantIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
    '@media screen and (max-width: 600px)': {
      width: 18,
      height: 18
    }
  },
  iconSection: {
    paddingTop: 5,
    flex: 5,
    display: 'flex',
    alignItems: 'center'
  },
  segmentBadge: {
    width: 20,
    height: 20
  },
  segmentValue: {
    color: '#FFFFFF',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    marginLeft: 5,
    marginTop: 3,
    '@media screen and (max-width: 750px)': {
      marginLeft: 3,
      fontSize: 16
    }
  },
  segmentBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    position: 'relative'
  },
  segmentValueDiv: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 25,
    zIndex: 1,
    '@media screen and (max-width: 750px)': {
      left: 5
    }
  },
  segmentParticipants: {
    fontSize: 12,
    color: '#212D40',
    fontFamily: 'roboto-light',
    flex: 4
  }
}));

interface IProps {
  highestSegments: any[],
  lowestSegments: any[],
  participantsStatus: any;
}

const AudienceLow = (props: IProps) => {
  const classes = useStyles();
  const {
    highestSegments, lowestSegments, participantsStatus
  } = props;
  const { sessionData, immersionIndex } = useSelector((state: any) => state.creatorExperienceManager);
  const { settings, cliped, immersion_overall } = useSelector((state: any) => state.analysis);
  const { pdfLoading } = settings;


  if (!!sessionData) {
//
  }
  /*
  console.log(audienceImmersions);
  console.log(audienceSafes);
  console.log(safetyData);
  console.log(isMobile);
  console.log(sessionData);
*/

  const getColor = (color: string) => {
    switch (color.toLowerCase()) {
      case 'green':
        return '#1DB859';
      case 'gray':
        return '#8192A2';
      case 'red':
        return '#ED564A';
      default:
        return '#8192A2';
    }
  };

  

  const SegmentBar = (props: any & { value: number, barColor: string }) => {
    return (
      <Box className={classes.segmentBar}>
        <div className={classes.segmentValueDiv}>
          <img className={classes.segmentBadge} src={'/assets/icons/overview/green-immersion-badge.svg'} alt={'badge'} />
          <div className={classes.segmentValue}>{props.value}</div>
        </div>
        <CustomSegmentBar {...props} />
      </Box>
    );
  };

  const getOverallIndex = useCallback(() => {
    if (cliped && cliped.score && cliped.score.immersion) {
      return cliped?.score?.immersion['immersion_index'];
    } else {
      return immersionIndex ? immersionIndex?.immersion_index : immersion_overall?.immersion_index;
    }
  }, [immersionIndex, immersion_overall, cliped]);

  const getVerticalBarHeight = (segments: any) => {
    const len = segments.length;
    return 100 * len + 30
  };

  const getNotPendingParticipants = (participantsStatus: any) => {
    return participantsStatus ? participantsStatus['completed'] + participantsStatus['error'] : 0
  };

  return (
    <div className={classes.root} id='audience'>
     



      {((highestSegments.length > 0 || lowestSegments.length > 0) && getNotPendingParticipants(participantsStatus) > 1) && (
        <div className={pdfLoading ? classes.foo : classes.foo}>
          
          
          {lowestSegments.length > 0 && (
            <div>
              <div className={pdfLoading ? classes.pdfSegmentCardSection : classes.segmentCardSection}>
                
                <div className={classes.segmentContent}>
                  <div style={{ height: '60px' }}>
                    <div style={{ display: 'flex' }}>
                      <div className={classes.segmentTagName} />
                      <div className={classes.segmentParticipants} style={{ zIndex: 1 }}>
                        <div style={{ marginLeft: `calc(${getOverallIndex()}% - 50px)` }}>
                          <div style={{ textAlign: 'center', width: '100px' }}>Overall = {getOverallIndex()}</div>
                        </div>
                        <div
                          style={{
                            borderRight: '1px solid #D9DEE3',
                            height: `${getVerticalBarHeight(lowestSegments)}px`,
                            width: `${getOverallIndex()}%`,
                            marginTop: '10px'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {lowestSegments.map((item, index) => (
                    <div key={index}>
                      <div className={classes.segmentRow}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div className={classes.segmentTagName}>{item['tag_name']}</div>
                          <div className={classes.segmentBarDiv}>
                            <SegmentBar
                              variant="determinate"
                              value={Number(item['immersion_data']['immersion_index'])}
                              barcolor={getColor(item['immersion_data']['color_indicator'])}
                            />
                          </div>
                        </div>
                        <div style={{ display: 'flex', marginTop: 5 }}>
                          <div className={classes.segmentTagName} />
                          <div className={classes.segmentParticipants}>
                            {item['total_paticipant']} {item['total_paticipant'] === 1 ? 'Participant' : 'Participants'}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
};

export default AudienceLow;